let voiceRecordJS = {
  data() {
    return {}
  },
  methods: {
    sendVoiceMessage() {
      let that = this;
      $('#touch-btn').on('touchstart', function () {
        // console.log("用户手指触语音发送按钮...");
        that.$wechat.startRecord({
          success: function (res) {
            console.log('开始录音成功' + JSON.stringify(res));
          },
          fail: function (res) {
            //录音失败
            console.log('开始录音失败' + JSON.stringify(res));
          }
        });
        // setTimeout(function () {
        //     //结束录音
        //     that.$wechat.stopRecord({
        //         success: function (res) {
        //             var localId = res.localId;
        //             console.log('获取录音localId' + localId);
        //         }
        //     });
        // }, 10000);
      });
      //手指在屏幕上移动时触发
      $('#touch-btn').on('touchmove', function (even) {
        console.log("用户手指在屏幕上移动...");
      });
      //手指离开屏幕时触发
      $('#touch-btn').on('touchend', function () {
        console.log("用户手离开屏幕...");
        that.$wechat.stopRecord({
          success: function (res) {
            console.log('停止录音成功' + JSON.stringify(res));
            that.$wechat.uploadVoice({
              localId: res.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function (res1) {
                console.log("上传的音频成功" + JSON.stringify(res1));
                var serverId = res1.serverId; // 返回音频的服务器端ID
                that.$axios.get('/api/v1.0/lonbonShop/saveWxFile', { // 传给serverId服务器端
                    params: {
                      mediaId: serverId
                    }
                  })
                  .then(function (response) {
                    if (response.status == 200) {
                      console.log('传给serverId服务器端成功' + JSON.stringify(response));
                    }
                  });
              },
              fail: function (res) {
                //录音失败
                console.log('上传的音频失败' + JSON.stringify(res));
              }
            });
          },
          fail: function (res) {
            //录音失败
            console.log('停止录音失败' + JSON.stringify(res));
          }
        });
      });
    },
  },
  mounted() {
    // this.sendVoiceMessage();
    //微信环境初始化
    // let currentUrl = location.href.split('#')[0];
    // let that = this;
    // if (that.$store.state.APPPAGE) {
    //   that.$store.state.APPPAGE.getWeiXinConfig(function (weiXinConfig) {
    //     console.log(currentUrl);
    //     that.$wechat.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: weiXinConfig.appId, // 必填，公众号的唯一标识
    //       timestamp: weiXinConfig.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: weiXinConfig.nonceStr, // 必填，生成签名的随机串
    //       signature: weiXinConfig.signature, // 必填，签名
    //       jsApiList: ['getNetworkType', 'startRecord', 'onVoiceRecordEnd', 'stopRecord', 'playVoice', 'stopVoice', 'uploadVoice'] // 必填，需要使用的JS接口列表
    //     });
    //     that.$wechat.ready(function () {
    //       // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    //       that.$wechat.getNetworkType({
    //         success: function (res) {
    //           var networkType = res.networkType; // 返回网络类型2g，3g，4g，wifi
    //           console.log('测试获取网络类型：' + networkType);
    //         }
    //       });
    //     });
    //     that.$wechat.error(function (res) {
    //       // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //       console.log('微信jssdk配置初始化失败');
    //       console.log(res);
    //     });
    //   }, currentUrl);
    // }
  }
}
export default voiceRecordJS = voiceRecordJS



// WEBPACK FOOTER //
// ./src/components/customerService/voiceRecord.js